


import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import check from "../assets/imgTwo/checkIcon.svg";
import list from "../assets/imgTwo/listIcon.svg";

const Terms = () => {
  return (
    <div className="app-wrapper">
      <Navbar />
      <div className="py-8 mt-24 flex-grow max-w-[83rem] md:mx-auto w-full">
        <div className="flex flex-col items-center justify-center text-center mb-8">
          <div className="relative flex flex-col items-center justify-center text-center md:w-[45em] h-[11em]">
            <span className="absolute left-0 top-0">
              <img src={check} alt="icon" />
            </span>
            <h2 className="text-center font-bold text-7xl my-6">Privacy Policy</h2>
            <p className="text-2xl md:mb-24">Document Effective August 01, 2023.<br></br>
              Last Updated May, 2025.</p>
            <span className="absolute right-0 bottom-0">
              <img src={list} alt="icon" />
            </span>
          </div>
        </div>


        <div className="flex flex-col md:flex-row lg:flex-row xl:flex-row md:px-5">
        </div>
        <div className="mb-8 p-6" id="policy-section">
          <h3 className="text-4xl font-bold py-4">Introduction</h3>
          <p className="leading-[2rem] py-2 text-xl">
            This privacy policy outlines how we collect, use, disclose, handle and protect your personal
            information which you have willfully shared with us when using our website and make use
            of our services in accordance with the Nigeria Data Protection Data Act (NDPA) 2023 and
            other relevant regulations. In collecting this information, we act as a data controller and, by
            law, we are required to provide you with information about us, about why and how we use
            your data, and about the rights you have over your data.
          </p>
          <h3 className="text-4xl font-bold py-4 mt-8">
            Who are we?
          </h3>
          <p className="leading-[2rem] py-2 text-xl">
            We are Uniswitch Technology Limited a financial services company whose registered office is
            located at 15 Moore Road Yaba, Lagos, Nigeria. You can contact us by post at the above
            address, by email at help@uniswitchng.com or by telephone (+234) 8033792075.
          </p>

          <h3 className="text-4xl font-bold py-4 mt-8">
            When you submit an enquiry via our website
          </h3>

          <p className="leading-[2rem] py-2 text-xl">
            When you submit an enquiry via our website, we ask you for your name, contact telephone number and email address.
            We use this information to respond to your query, including providing you with any requested information about our products and services. We may also email you several times after your enquiry in order to follow up on your interest and ensure that we have answered your it to your satisfaction. We will do this based on our legitimate interest in providing accurate information prior to a sale.
            Users enquiries are stored in our database and also sent as an email notification to registered customer support emails.
            We do not use the information you provide to make any automated decisions that might affect you.
            We keep enquiry emails for two years, after which they are securely archived and kept for seven years, when we delete them. CRM records are kept for three years after the last contact with you.
          </p>

          <h3 className="text-4xl font-bold py-4 mt-8">
            When you purchase a product from our website
          </h3>

          <p className="leading-[2rem] py-2 text-xl">

            When you purchase products from us online, we ask you for your name, address, contact telephone number, email address and debit card information. We also record your IP (Internet Protocol) address, which is the address of your computer on the Internet.
            We will use your information to verify your debit card details for your purchase, process your order and to send you your products. We will also send you a receipt via email and we may use your telephone number to contact you regarding your purchase.
            We require this information in order to process your payment, deliver your products or services and fulfil our contract with you.
            Your information is stored on our website and on our cloud server. Your debit card details are passed to a third-party payment processor which is based in Nigeria and with whom we have a contractual agreement which provides effective safeguards for your information. We do not retain your debit card information.
            We do not use the information you provide to make any automated decisions that might affect you.
            We can reuse the authorization token gotten after a successful card charging to re-charge a card for a service that requires periodic recurring payments.
            We keep your order information for an indefinite period, as the licenses we sell for our products are renewed.
          </p>


          <h3 className="text-2xl font-bold py-4 mt-8">
            Consent-based signups
          </h3>

          <p className="leading-[2rem] py-2 text-xl">
            The personal data collected include: Name, Email address, phone number
            The purpose of this transaction is to onboard users to our platform/services
            The lawful basis used is consensual agreement.
            Personal data collected could be shared with third-party service providers.
            The personal data is stored in our cloud hosted database.
            No automated decisions are made on the data.
            The retention policy for personal user data is indefinite.
          </p>


          <h3 className="text-4xl font-bold py-4 mt-8">
            Your rights as a data subject
          </h3>
          <p className="leading-[2rem] py-2 text-xl">
            By law, you can ask us what information we hold about you, and you can ask us to correct it if it is inaccurate. If we have asked for your consent to process your personal data, you may withdraw that consent at any time.
            If we are processing your personal data for reasons of consent or to fulfil a contract, you can ask us to give you a copy of the information in a machine-readable format so that you can transfer it to another provider.
            If we are processing your personal data for reasons of consent or legitimate interest, you can request that your data be erased.
            You have the right to ask us to stop using your information for a period of time if you believe we are not doing so lawfully.
            Finally, in some circumstances you can ask us not to reach decisions affecting you using automated processing or profiling.
            To submit a request regarding your personal data by email, post or telephone, please use the contact information provided above in the Who Are We section of this policy.
          </p>

          <h3 className="text-4xl font-bold py-4 mt-8">
            Your right to complain
          </h3>
          <p className="leading-[2rem] py-2 text-xl">
            If you have a complaint about our use of your information, we would prefer you to contact us directly in the first instance so that we can address your complaint. However, you can also contact the Data Protection Commission via their website at  https://ndpc.gov.ng/ or write to them at:<br></br>
            Nigeria Data Protection BureauNo, 5 Donau CrescentOff Amazon Street,Maitama Abuja, Nigeria.
          </p>


          <h3 className="text-4xl font-bold py-4 mt-8">
            Updates to this privacy policy
          </h3>
          <p className="leading-[2rem] py-2 text-xl">
            We regularly review and, if appropriate, update this privacy policy from time to time, and as our services and use of personal data evolves. If we want to make use of your personal data in a way that we have not previously identified, we will contact you to provide information about this and, if necessary, to ask for your consent.
            We will update the version number and date of this document each time it is changed.
          </p>
        </div>
      </div>
      <Footer className="isms-footer" />
    </div>
  );
};

export default Terms;
